const GROUPS = Object.freeze({
  CARS_TRUCKS_SUVS_VANS: 'cars-trucks-suvs-vans',
  HORSE_LIVESTOCK_TRAILERS: 'horse-livestock-trailers',
  HORSE_TRAILERS: 'horse-trailers',
  LIVESTOCK_TRAILERS: 'livestock-trailers',
  RV: 'rv',
  TRAILERS: 'trailers',
  TRUCKS: 'trucks',
});

export default GROUPS;
